import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "serp__filter--range-container q-row" }
const _hoisted_2 = { class: "serp__filter--range-min q-col-6" }
const _hoisted_3 = { class: "q-small" }
const _hoisted_4 = { class: "q-input-group-sm q-mb-3 q-d-flex" }
const _hoisted_5 = ["data-field", "id", "name", "placeholder"]
const _hoisted_6 = {
  key: 0,
  class: "q-input-group-text q-unit"
}
const _hoisted_7 = { class: "serp__filter--range-max q-col-6" }
const _hoisted_8 = { class: "q-small" }
const _hoisted_9 = { class: "q-input-group-sm q-mb-3 q-d-flex" }
const _hoisted_10 = ["id", "name", "placeholder"]
const _hoisted_11 = {
  key: 0,
  class: "q-input-group-text q-unit"
}

import {ref, inject} from 'vue';
import {useFiltersStore} from "@/store/SerpPage/FiltersStore";
import {useSerpResultsStore} from "@/store/SerpPage/SerpResultsStore";
import {storeToRefs} from "pinia";
import {formatPrice} from "@/core/utils";
import {SmartSearchConfig} from "@/main";
import {SmartSearchTranslationsInterface} from "@/core/types";

export default /*#__PURE__*/_defineComponent({
  __name: 'InputRangeItem',
  props: ['filterData', 'field'],
  emits: ['closeDropdown'],
  setup(__props, { emit }) {

const props = __props;

const filtersStore = useFiltersStore()


const minInputValue = ref<number | null>(props.filterData.min.toFixed(2));
const maxInputValue = ref<number | null>(props.filterData.max.toFixed(2));
const unit = ref(props.filterData.unit)

const serpStore = useSerpResultsStore()
const {getCurrencyCode} = storeToRefs(serpStore)
const {removeDecimals} = SmartSearchConfig.value.appConfiguration
const handleMinInputChange = (event: Event) => {
  filtersStore.updateRangeValue(event, props.field, props.filterData, event.target.value, maxInputValue.value);
  emit('closeDropdown');
}



const handleMaxInputChange = (event: Event) => {
  filtersStore.updateRangeValue(event, props.field, props.filterData, minInputValue.value, event.target.value);
  emit('closeDropdown');
}
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const SmartSearchTranslations = inject<SmartSearchTranslationsInterface>('SmartSearchTranslations')!


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("small", _hoisted_3, _toDisplayString(_unref(SmartSearchTranslations).filters.from), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("input", {
          class: _normalizeClass(["serp__filter--range-min-input q-form-control q-p-1 q-p-1 q-text-end", {'q-with-unit': !!unit.value}]),
          "data-field": __props.field,
          id: __props.field + '_min',
          name: __props.field + '_min',
          placeholder: __props.field === 'price' ? _unref(formatPrice)(minInputValue.value, _unref(getCurrencyCode), _unref(removeDecimals)) :minInputValue.value,
          min: 0,
          onChange: _cache[0] || (_cache[0] = ($event: any) => (handleMinInputChange($event)))
        }, null, 42, _hoisted_5),
        (unit.value)
          ? (_openBlock(), _createElementBlock("small", _hoisted_6, _toDisplayString(unit.value), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("small", _hoisted_8, _toDisplayString(_unref(SmartSearchTranslations).filters.to), 1),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("input", {
          class: _normalizeClass(["serp__filter--range-max-input q-form-control q-p-1 q-text-end", {'q-with-unit': !!unit.value}]),
          id: __props.field + '_max',
          name: __props.field + '_max',
          placeholder: __props.field === 'price' ? _unref(formatPrice)(maxInputValue.value, _unref(getCurrencyCode), _unref(removeDecimals)) :maxInputValue.value,
          min: 0,
          onChange: _cache[1] || (_cache[1] = ($event: any) => (handleMaxInputChange($event)))
        }, null, 42, _hoisted_10),
        (unit.value)
          ? (_openBlock(), _createElementBlock("small", _hoisted_11, _toDisplayString(unit.value), 1))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})